// Payment Methods
export const PAYMENT_METHODS = {
  CASH: "Cash",
  CARD: "Card",
  UPI: "UPI",
  LOYALTY: "Loyalty",
  ADVANCE: "Customer Advance",
  GIFT_VOUCHER: "Gift Voucher",
  STORE_WALLET: "Store Wallet",
  PROMOTIONAL_CREDIT: "Promotional Credit",
  CREDIT: "Credit",
  CHEQUE: "Cheque",
  BANK_TRANSFER: "Bank Transfer",
  MIXED: "Mixed",
} as const;

export type PaymentMethodKey = keyof typeof PAYMENT_METHODS;
export type PaymentMethodValue = (typeof PAYMENT_METHODS)[PaymentMethodKey];

/**
 * Tenders with a complete, cashier-usable checkout flow.
 *
 * Gift vouchers and promotional credit deliberately remain outside this list
 * until issuance, validation, balance, expiry, and redemption are implemented.
 */
export const POS_CHECKOUT_PAYMENT_METHODS = [
  "CASH",
  "UPI",
  "CARD",
  "LOYALTY",
  "ADVANCE",
  "BANK_TRANSFER",
  "CHEQUE",
  "STORE_WALLET",
] as const satisfies readonly PaymentMethodKey[];

export type PosCheckoutPaymentMethod =
  (typeof POS_CHECKOUT_PAYMENT_METHODS)[number];

const POS_CHECKOUT_PAYMENT_METHOD_SET = new Set<string>(
  POS_CHECKOUT_PAYMENT_METHODS,
);

export function isPosCheckoutPaymentMethod(
  method: string,
): method is PosCheckoutPaymentMethod {
  return POS_CHECKOUT_PAYMENT_METHOD_SET.has(method);
}
